module.exports = __webpack_public_path__ + "img/Login-Seite_Teilnahmebedingungen.9fd90ce5.png";